import(/* webpackMode: "eager" */ "/vercel/path0/app/terms-of-service/page.tsx");
